module.exports = __webpack_public_path__ + "static/media/sites_yellow-01.6704373d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/sites_yellow-01.png
// module id = 7699
// module chunks = 0